import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Attachment, AttachmentCategory, ApiResponse, PaginatedResponse, DialogCloseResult } from '../attachment.interface';

@Component({
  selector: 'meu-modal-create-attachment',
  templateUrl: './modal-create-attachment.component.html',
  styleUrls: ['./modal-create-attachment.component.scss']
})
export class ModalCreateAttachmentComponent implements OnInit {
  attachmentForm: FormGroup;
  isLoading = false;
  attachmentId: string;
  host: string;
  imagePreview: string | ArrayBuffer | null = null;
  selectedImageFile: File | null = null;
  selectedDocumentFile: File | null = null;
  documentFileName: string = '';
  currentImagePath: string = '';
  currentFilePath: string = '';
  currentFileSize: string = '';
  lstCategories: AttachmentCategory[] = [];
  private apiUrl = environment.backendhost + '/api/attachments';
  private categoryApiUrl = environment.backendhost + '/api/attachment_categories';

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalCreateAttachmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string },
    private toastr: ToastrService,
    private http: HttpClient,
    private ref: ChangeDetectorRef
  ) {
    this.attachmentId = data.id;
    this.host = environment.backendhost;
  }

  ngOnInit() {
    this.createForm();
    this.loadCategories();
    if (this.attachmentId) {
      this.loadAttachmentDetail();
    }
  }

  createForm() {
    this.attachmentForm = this.fb.group({
      name: ['', Validators.required],
      attachment_category_id: ['', Validators.required],
      image_file: [null],
      is_paid: [false],
      price: [0],
      limit_download: [null]
    });
  }

  loadCategories() {
    const params = {
      Page: '1',
      PageSize: '1000'
    };
    this.http.get<ApiResponse<PaginatedResponse<AttachmentCategory>>>(this.categoryApiUrl, { params }).subscribe(
      (res) => {
        if (res.success) {
          this.lstCategories = res.data.collection;
          this.ref.detectChanges();
        }
      }
    );
  }

  loadAttachmentDetail() {
    this.loadFromListAPI();
  }
  loadFromListAPI() {
    

    this.http.get<ApiResponse<PaginatedResponse<Attachment>>>(this.apiUrl).subscribe(
      (res) => {
        
        if (res.success && res.data && res.data.collection) {
          

          const attachment = res.data.collection.find(item => item.id === this.attachmentId);

          if (attachment) {
            this.patchAttachmentData(attachment);
          } else {

            this.toastr.error('Không tìm thấy file với ID: ' + this.attachmentId);
          }
        } else {
          this.toastr.error('Không thể tải danh sách file');
        }
      },
      (error) => {
        console.error('Error loading attachment list:', error);
        this.toastr.error('Có lỗi xảy ra khi tải thông tin file');
      }
    );
  }

  patchAttachmentData(attachment: Attachment) {
    
    this.attachmentForm.patchValue({
      name: attachment.name || '',
      attachment_category_id: attachment.attachment_category_id || '',
      is_paid: attachment.is_paid || false,
      price: attachment.price || 0,
      limit_download: attachment.limit_download !== undefined ? attachment.limit_download : null
    });
    
    

    if (attachment.image_path) {
      this.imagePreview = this.host + attachment.image_path;
      this.currentImagePath = attachment.image_path;
    }

    if (attachment.file_name) {
      this.documentFileName = attachment.file_name;
      this.currentFilePath = attachment.physical_path || '';
      this.currentFileSize = attachment.file_size ? attachment.file_size.toString() : '';
    }
    
    this.ref.detectChanges();
    this.toastr.success('Đã tải thông tin file: ' + attachment.name);
  }

  loadAttachmentDetailWithFilter() {
    this.http.get<ApiResponse<PaginatedResponse<Attachment>>>(`${this.apiUrl}?Filters=id==${this.attachmentId}`).subscribe(
      (res) => {
        if (res.success && res.data && res.data.collection && res.data.collection.length > 0) {
          const attachment = res.data.collection[0];
          this.attachmentForm.patchValue({
            name: attachment.name,
            attachment_category_id: attachment.attachment_category_id
          });
          if (attachment.image_path) {
            this.imagePreview = this.host + attachment.image_path;
            this.currentImagePath = attachment.image_path;
          }
          if (attachment.file_name) {
            this.documentFileName = attachment.file_name;
            this.currentFilePath = attachment.physical_path || '';
            this.currentFileSize = attachment.file_size ? attachment.file_size.toString() : '';
          }
          this.ref.detectChanges();
        } else {
          this.toastr.error('Không tìm thấy thông tin file');
        }
      },
      (error) => {
        this.toastr.error('Không thể tải thông tin file');
        console.error('Error loading attachment:', error);
      }
    );
  }

  onFileSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files && target.files[0];
    if (file) {
      this.selectedImageFile = file;
      
      // Preview image
      const reader = new FileReader();
      reader.onload = (e: Event) => {
        const fr = e && (e.target as FileReader) ? (e.target as FileReader) : null;
        this.imagePreview = fr && fr.result ? fr.result : null;
        this.ref.detectChanges();
      };
      reader.readAsDataURL(file);
    }
  }

  onDocumentSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files && target.files[0];
    if (file) {
      this.selectedDocumentFile = file;
      this.documentFileName = file.name;
      this.attachmentForm.patchValue({ document_file: file });
      this.ref.detectChanges();
    }
  }

  removeImage() {
    this.selectedImageFile = null;
    if (!this.attachmentId) {
      this.imagePreview = null;
    } else {
      this.imagePreview = null;
      this.currentImagePath = ''; 
    }
    this.attachmentForm.patchValue({ image_file: null });
  }

  removeDocument() {
    this.selectedDocumentFile = null;

    if (!this.attachmentId) {
      this.documentFileName = '';
    } else {

      this.selectedDocumentFile = null;
    }
    this.attachmentForm.patchValue({ document_file: null });
  }

  viewCurrentFile() {
    if (this.currentFilePath) {
      const fileUrl = this.currentFilePath.startsWith('/api/') 
        ? this.host + this.currentFilePath 
        : this.currentFilePath;
      window.open(fileUrl, '_blank');
    }
  }

  downloadCurrentFile() {
    if (this.currentFilePath) {
      const downloadUrl = this.currentFilePath.startsWith('/api/') 
        ? this.host + this.currentFilePath 
        : this.currentFilePath;
      window.open(downloadUrl, '_blank');
    }
  }

  onSubmit() {
    if (this.attachmentForm.invalid) {
      this.toastr.warning('Vui lòng điền đầy đủ thông tin');
      return;
    }

    this.isLoading = true;

    if (this.attachmentId) {
      // Update existing attachment
      this.updateAttachment();
    } else {
      // Create new attachment
      this.createAttachment();
    }
  }

  createAttachment() {

    const formData = new FormData();
    const nameControl = this.attachmentForm.get('name');
    const categoryControl = this.attachmentForm.get('attachment_category_id');
    const isPaidControl = this.attachmentForm.get('is_paid');
    const priceControl = this.attachmentForm.get('price');
    const limitDownloadControl = this.attachmentForm.get('limit_download');
    
    if (nameControl && nameControl.value) {
      formData.append('name', nameControl.value);
    }
    if (categoryControl && categoryControl.value) {
      formData.append('attachment_category_id', categoryControl.value);
    }

    const isPaid: boolean = isPaidControl ? !!isPaidControl.value : false;
    formData.append('is_paid', String(isPaid));

    if (isPaid) {
      formData.append('price', priceControl && priceControl.value ? String(priceControl.value) : '0');
      if (limitDownloadControl && limitDownloadControl.value !== null && limitDownloadControl.value !== '') {
        formData.append('limit_download', String(limitDownloadControl.value));
      }
    } else {
      formData.append('price', '0');
    }
    

    if (this.selectedImageFile) {
      formData.append('image_file', this.selectedImageFile);
    }

    this.http.post<ApiResponse<Attachment>>(this.apiUrl, formData).subscribe(
      (res) => {
        this.isLoading = false;
        if (res.success && res.data && res.data.id) {
          this.toastr.success('Tạo file thành công! Bạn có thể upload file thực ở bước tiếp theo.');
          this.dialogRef.close({ event: true, type: 'create', data: res.data } as DialogCloseResult);
        } else {
          console.error('[POST attachment] success=false, message=', res.message, 'full=', res);
          this.toastr.error(res.message || 'Không thể tạo file');
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('[POST attachment] HTTP error', error);
        this.toastr.error('Có lỗi xảy ra khi tạo file mới');
      }
    );
  }

  uploadFile(attachmentId: string) {
    if (!this.selectedDocumentFile) return;
    
    const formData = new FormData();
    formData.append('file', this.selectedDocumentFile);

    this.http.put<ApiResponse<Attachment>>(`${this.apiUrl}/${attachmentId}/upload`, formData).subscribe(
      (res) => {
        this.isLoading = false;
        if (res.success) {
          this.toastr.success('Tạo file và upload thành công');
          this.dialogRef.close({ event: true, type: 'create' } as DialogCloseResult);
        } else {
          this.toastr.warning('File đã tạo nhưng không thể upload. Mã file: ' + attachmentId);
          this.dialogRef.close({ event: true, type: 'create' } as DialogCloseResult);
        }
      },
      (error) => {
        this.isLoading = false;
        this.toastr.warning('File đã tạo nhưng không thể upload. Mã file: ' + attachmentId);
        this.dialogRef.close({ event: true, type: 'create' } as DialogCloseResult);
        console.error('Error uploading file:', error);
      }
    );
  }

  uploadImage(attachmentId: string) {

    if (!this.selectedImageFile) return;
    
    const formData = new FormData();
    formData.append('image_file', this.selectedImageFile);

    this.http.put<ApiResponse<Attachment>>(`${this.apiUrl}/${attachmentId}`, formData).subscribe(
      (res) => {
        this.isLoading = false;
        if (res.success) {
          this.dialogRef.close({ event: true, type: 'create' } as DialogCloseResult);
        } else {
          this.toastr.warning('File đã tạo nhưng không thể upload ảnh thumbnail');
          this.dialogRef.close({ event: true, type: 'create' } as DialogCloseResult);
        }
      },
      (error) => {
        this.isLoading = false;
        this.toastr.warning('File đã tạo nhưng không thể upload ảnh thumbnail');
        this.dialogRef.close({ event: true, type: 'create' } as DialogCloseResult);
      }
    );
  }

  updateAttachment() {
    if (this.selectedDocumentFile) {
      const fileFormData = new FormData();
      fileFormData.append('file', this.selectedDocumentFile);
      
      this.http.put<ApiResponse<Attachment>>(`${this.apiUrl}/${this.attachmentId}/upload`, fileFormData).subscribe(
        (res) => {
          if (res.success) {

            this.handleImageAndMetadataUpdate();
          } else {
            this.isLoading = false;
            this.toastr.error('Không thể upload file mới');
          }
        },
        (error) => {
          this.isLoading = false;
          this.toastr.error('Có lỗi xảy ra khi upload file');
        }
      );
    } else {

      this.handleImageAndMetadataUpdate();
    }
  }

  handleImageAndMetadataUpdate() {
    if (this.selectedImageFile) {
      const imageFormData = new FormData();
      imageFormData.append('image_file', this.selectedImageFile);
      
      this.http.put<ApiResponse<Attachment>>(`${this.apiUrl}/${this.attachmentId}/image`, imageFormData).subscribe(
        (res) => {
          if (res.success) {
            if (res.data && res.data.image_path) {
              this.currentImagePath = res.data.image_path;
            }
            this.updateMetadata();
          } else {
            this.updateMetadata();
          }
        },
        (error) => {
          console.error('Error uploading image:', error);
          this.updateMetadata();
        }
      );
    } else {
      this.updateMetadata();
    }
  }

  updateMetadata() {
    const nameControl = this.attachmentForm.get('name');
    const categoryControl = this.attachmentForm.get('attachment_category_id');
    const isPaidControl = this.attachmentForm.get('is_paid');
    const priceControl = this.attachmentForm.get('price');
    const limitDownloadControl = this.attachmentForm.get('limit_download');

    const isPaid: boolean = isPaidControl ? !!isPaidControl.value : false;
    
    const updateData: {
      id: string;
      name: string;
      attachment_category_id: string;
      image_path: string;
      is_paid: boolean;
      price: number;
      limit_download: number | null;
    } = {
      id: this.attachmentId,
      name: nameControl && nameControl.value ? nameControl.value : '',
      attachment_category_id: categoryControl && categoryControl.value ? categoryControl.value : '',
      image_path: this.currentImagePath || '',
      is_paid: isPaid,
      price: isPaid && priceControl && priceControl.value ? Number(priceControl.value) : 0,
      limit_download: isPaid && limitDownloadControl && limitDownloadControl.value !== null && limitDownloadControl.value !== ''
        ? Number(limitDownloadControl.value)
        : null
    };


    this.http.put<ApiResponse<Attachment>>(`${this.apiUrl}/${this.attachmentId}`, updateData, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).subscribe(
      (res) => {
        this.isLoading = false;
        if (res.success) {
          this.toastr.success('Cập nhật thành công');
          this.dialogRef.close({ event: true, type: 'update' } as DialogCloseResult);
        } else {
          this.toastr.error(res.message || 'Không thể cập nhật');
        }
      },
      (error) => {
        this.isLoading = false;
        this.toastr.error('Có lỗi xảy ra khi cập nhật');
        console.error('Error updating attachment:', error);
      }
    );
  }

  onCancel() {
    this.dialogRef.close();
  }
}
